import React from 'react';
import { Handle, Position } from '@xyflow/react';

function RouteTableNode({ data, selected }) {
  return (
    <div
      className={`relative rounded-lg border-2 p-3 transition-colors ${
        selected
          ? 'border-indigo-500 bg-indigo-50/70 dark:bg-indigo-900/30'
          : 'border-indigo-300 bg-indigo-50/40 dark:bg-indigo-900/20'
      }`}
      style={{ width: 220, height: 120 }}
    >
      <Handle type="target" position={Position.Top} className="!bg-indigo-500" />
      <div className="mb-1 flex items-center gap-2">
        <svg className="h-4 w-4 text-indigo-600 dark:text-indigo-400 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} aria-hidden="true">
          <path d="M3 6h18M3 12h18M3 18h18M7 6v12M17 6v12" />
        </svg>
        <span className="text-sm font-semibold text-indigo-900 dark:text-indigo-100 truncate">{data.name}</span>
      </div>
      {data.routes && (
        <span className="inline-block bg-indigo-100 text-indigo-800 dark:bg-indigo-900 dark:text-indigo-200 text-xs font-mono px-2 py-0.5 rounded">
          {data.routes.split('\n').length} route(s)
        </span>
      )}
      <div className="mt-1 text-xs text-gray-500 dark:text-gray-400">Route Table</div>
      <Handle type="source" position={Position.Bottom} className="!bg-indigo-500" />
    </div>
  );
}

export default RouteTableNode;
